import { render, staticRenderFns } from "./add&edit.vue?vue&type=template&id=092581a0&scoped=true&"
import script from "./add&edit.vue?vue&type=script&lang=js&"
export * from "./add&edit.vue?vue&type=script&lang=js&"
import style0 from "./add&edit.vue?vue&type=style&index=0&id=092581a0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092581a0",
  null
  
)

export default component.exports